// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    baseUrl: 'https://voice.gramvaani.org/vapp/api/v1/',
    cacheUrl: 'https://4f0ttmky5k.execute-api.ap-south-1.amazonaws.com/dev/get/?',
    global_unm : [],
    global_mod : [],
    akstr: 'AKIAYX7PSKXZWYXERM7Q',
    skstr: 'uBERKVF0JdVYYbAR7cTQfemFiNm0MkWqwMH4HzYB',
    region: 'ap-south-1'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
